export const loaderPortalId = (messageId: string) =>
  `message-${messageId}-loader-portal`;
